import { useEffect, useRef, useState } from 'react';

//How the site's top bars and a page's "Find a session" search (JumpTo.js) talk to each other, without a bar
//importing the search itself. While the search is on the page it marks <html> with PRESENT_ATTR and listens for
//OPEN_EVENT; the bars then show a search icon that sends that event instead of opening the site-wide search: the
//signed-in navbar (navBar/NavBar.tsx, which also hides its bell and cart there) and the signed-out bar of a public
//agenda (publicSignIn/PublicSignInPrompt.tsx). Omerson 10/27/2026, BSM 2026 agenda: "find should open the search on
//the page for agenda and NOT the main search functionality for the whole site... notification bell and cart be
//removed since they dont have purpose anyway"; "when you're not logged in that search icon should show also since
//that is a functionality of that page alone".
export const PRESENT_ATTR = 'data-pb-jump';
export const OPEN_EVENT = 'pb-jump-to:open';
//Set while the search's panel is open (JumpTo.js).
export const OPEN_ATTR = 'data-pb-jump-open';

//True while the page shows the search.
export const useAgendaSearch = () => {
  const html = document.documentElement;
  const [present, setPresent] = useState(() => html.hasAttribute(PRESENT_ATTR));
  useEffect(() => {
    const update = () => setPresent(html.hasAttribute(PRESENT_ATTR));
    const observer = new MutationObserver(update);
    observer.observe(html, {
      attributes: true,
      attributeFilter: [PRESENT_ATTR]
    });
    update();
    return () => observer.disconnect();
  }, [html]);
  return present;
};

//Props for a bar's search icon. The search closes itself on the mousedown of a click outside it, so whether it was
//open is read at mousedown: a click on the icon then closes it instead of opening it again.
export const useAgendaSearchButton = () => {
  const wasOpen = useRef(false);
  return {
    onMouseDown: () => {
      wasOpen.current = document.documentElement.hasAttribute(OPEN_ATTR);
    },
    open: () => {
      if (!wasOpen.current) window.dispatchEvent(new Event(OPEN_EVENT));
    }
  };
};
